import { Radio } from "@mui/material";
import { styled } from "@mui/material/styles";

const BoxIcon = styled("span")({
    width: 20,
    height: 20,
    borderRadius: 6,
    border: "2px solid #cbd5e1",
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    transition: "all 0.18s ease",
});

const BoxCheckedIcon = styled(BoxIcon)({
    backgroundColor: "#1e293b",
    borderColor: "#1e293b",
    animation: "checkScale 0.15s ease-out",

    "&::after": {
        content: '""',
        width: 8,
        height: 8,
        backgroundColor: "#fff",
        borderRadius: 2,
    },

    "@keyframes checkScale": {
        from: { transform: "scale(0.85)" },
        to: { transform: "scale(1)" },
    },
});

export default function SquareRadio(props) {
    return (
        <Radio
            disableRipple
            color="default"
            checkedIcon={<BoxCheckedIcon />}
            icon={<BoxIcon />}
            {...props}
        />
    );
}
